/**
 * Typed client for ReportsHandler.ashx and dynamic report CRUD operations.
 */
import type { DynamicReport, ReportListQuery } from '../models/report';
import { actionUrl, request } from './http';

export async function getReportsList(query: ReportListQuery): Promise<DynamicReport[]> {
  return request<DynamicReport[]>(actionUrl('ReportsHandler', 'GetReportsList'), { method: 'POST', body: query });
}

export async function getEditableReport(reportId: number): Promise<DynamicReport> {
  return request<DynamicReport>(actionUrl('ReportsHandler', 'GetEditableReport', { Id: reportId }), { method: 'POST' });
}

export async function createReport(report: DynamicReport): Promise<number> {
  const response = await request<number | string>(actionUrl('ReportsHandler', 'InsertReport'), { method: 'POST', body: report });
  return Number(response);
}

export async function updateReport(report: DynamicReport): Promise<boolean> {
  const response = await request<boolean | string>(actionUrl('ReportsHandler', 'EditReport'), { method: 'POST', body: report });
  return response === true || response === 'true';
}

export async function removeReport(reportId: number): Promise<void> {
  await request(actionUrl('ReportsHandler', 'RemoveReport', { Id: reportId }), { method: 'POST' });
}
